import styled from "styled-components";
export const Styles = styled.div`
  .container {
    height: 80vh;
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
    color: var(--main-blue);
    .error-number {
      font-family: "Raleway";
      font-size: 12rem;
      font-weight: 500;
      display: flex;

      .first-four {
        transition: 0.8s;
        transform: ${({ moveNumber }) =>
          moveNumber ? " rotateY(0deg)" : "rotateY(-180deg)"};
      }
      .second-four {
        transition: 0.3s;
        transform: ${({ moveNumber }) =>
          moveNumber ? " rotateY(0deg)" : "rotateY(180deg)"};
      }
      /* transform: rotateY(181deg); */
    }
    .error-Message {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .text-message {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 2rem;
        font-size: 2rem;
        font-family: "Poppins";
        font-weight: 600;
        span {
          font-size: 1rem;
          font-weight: 500;
        }
      }
    }
  }
`;
